import { fetchData } from 'services/fetchData';

import { authStore } from 'stores';

/**
 * Send a request to the API to retrieve all Reports for an Account.
 * @returns array of reports
 */
export const getUARReportsByAcc = async (filterCriteria) => {
    const { jwtToken } = authStore.getState('passwordSession').value.sessionDetails;

    const httpOptions = {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
            'Content-Type': 'application/json'
        },
        method: 'GET',
        withCredentials: true
    };

    const requestPath = `/uarReport/byAcc?filterCriteria=${encodeURIComponent(JSON.stringify(filterCriteria))}`;
    const { data } = await fetchData(requestPath, httpOptions);
    return data;
};
